<div class="mb-2 flex h-8 items-center justify-between px-2">
  <h5 class="typo-h5-semibold flex items-center justify-center text-text-secondary">
    {{ visitDate() | date }}

    @if (isTimeZoneDifferentFromLocal()) {
      <svg-icon
        class="relative top-[-2px] ml-2 text-primary-blue"
        size="sm"
        key="px-16-info"
        [libUiTooltip]="timezoneTooltip"
        tooltipPosition="right-bottom"
      ></svg-icon>
      <ng-template #timezoneTooltip>
        <div class="typo-h5 p-2">
          {{ 'notes_visit_timezone_notice' | translate }}
        </div>
      </ng-template>
    }
  </h5>
</div>
<div class="flex flex-col gap-y-1.5 overflow-hidden rounded-2xl">
  @for (item of items(); track item.id) {
    <lib-ffd-note-item
      class="rounded-2xl border-[1.5px] border-background-white hover:cursor-pointer"
      [ngClass]="selectedNoteId() === item.id ? 'border-primary-blue' : item.hasBeenCopied ? '' : 'border-states-orange'"
      [noteId]="item.id"
      [noteTitle]="item.title ?? ''"
      [hasBeenCopied]="item.hasBeenCopied"
      [date]="item.date"
      [isLocked]="false"
      [isProvisional]="false"
      [noteContent]="item.content"
      [disabled]="disabled()"
      [searchTerm]="searchTerm() ?? ''"
      (deleteNote)="onDeleteNoteClick(item.id)"
      (editNote)="onEditNoteClick(item.id)"
      (click)="onNoteClick(item.id)"
    ></lib-ffd-note-item>
  }
</div>
